export const CLIENT_CATEGORIES = ['중앙정부·공공기관', '지방자치단체', '공기업·준정부기관'];
